import breadcrumbs from '@/components/breadcrumbs/index.vue'
import notificationsFilter from '@/modules/notifications/filter/index.vue'
import notificationsList from '@/modules/notifications/list/index.vue'

export default {
  name: 'notifications',
  //---components
  components: {
    breadcrumbs,
    notificationsFilter,
    notificationsList
  },
  //---data
  data () {
    return {}
  },
  //---hooks
  //---methods
}